import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';
import Logo from '../components/logo';
import SocialLinks from '../components/social-links';

const IndexPage = () => (
  <Layout>
    <SEO
      title="Home"
      keywords={[`freelance`, `graphic`, `designer`, `photographer`]}
    />
    <Logo />

    <SocialLinks />
  </Layout>
);

export default IndexPage;
